var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import classNames from 'classnames';
import "./styles.css";
export var LinearProgress = function (_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 4 : _c, _d = _a.type, type = _d === void 0 ? 'solo' : _d, _e = _a.cycled, cycled = _e === void 0 ? false : _e, className = _a.className, style = _a.style, props = __rest(_a, ["value", "strokeWidth", "type", "cycled", "className", "style"]);
    var limitedValue = useMemo(function () { return (value > 100 ? 100 : value); }, [value]);
    var progressBarTransform = useMemo(function () { return "translateX(-" + (100 - limitedValue) + "%)"; }, [limitedValue]);
    var progressBarHeight = useMemo(function () { return strokeWidth + "px"; }, [strokeWidth]);
    return (React.createElement("span", __assign({}, props, { style: __assign({ height: progressBarHeight }, style), className: classNames('lk-ui_progress', 'lk-ui_progress__linear', "lk-ui_progress__linear-" + type, className) }),
        React.createElement("span", { style: { transform: progressBarTransform }, className: classNames('lk-ui_progress-bar', cycled && 'lk-ui_progress-bar__cycled', "lk-ui_progress-bar__" + type) })));
};
